import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { MatDialogRef } from "@angular/material/dialog";

import { finalize } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";

import { DataService } from "../Services/dataservice.service";
import { FlowServiceService } from "../Services/flow-service.service";
import { UserserviceService } from "../Services/userservice.service";

@Component({
  selector: "app-dialog-example",
  templateUrl: "./dialog-example.component.html",
  styleUrls: ["./dialog-example.component.scss"],
})
export class DialogExampleComponent implements OnInit {
  flowData: any;
  userData: any;
  imageSource: any;
  description: any;
  nextCount: number;
  itemsRequired: number;
  stepCount: number;
  progressPercentage: number;
  progressBy: number;
  dataSource = [];
  dataSourceSteps = [];
  showimage: boolean;
  isDeleting = false;

  constructor(
    private userserviceService: UserserviceService,
    private flowServiceService: FlowServiceService,
    public formbuilder: UntypedFormBuilder,
    private dataService: DataService,
    private toastr: ToastrService,
    public router: Router,
    public dialogRef: MatDialogRef<DialogExampleComponent>
  ) {}

  ngOnInit() {
    window.scrollTo(0, 0);

    this.flowData = JSON.parse(localStorage.getItem("flow"));
    if (this.flowData != null) {
      this.imageSource = this.flowData.Url;
      this.description = this.flowData.Description;
      this.nextCount = 0;
      this.itemsRequired = 0;
      this.stepCount = 0;
      const steps = this.flowData.Steps.length + 2;
      this.progressBy = 100 / steps;
      this.progressPercentage = 100 / steps;

      if (this.flowData === "default message") {
        this.flowData = JSON.parse(localStorage.getItem("recentflow"));
      }

      this.dataSource = this.flowData.Components;
      this.loadSteps(this.flowData.Steps);
    }
  }

  private getUserEmail(): string | null {
    return this.userData?.emailAddress || this.userData?.EmailAddress || null;
  }

  private getFlowOwnerEmail(): string | null {
    return this.flowData?.CustomerEmail || this.flowData?.customerEmail || null;
  }

  presetUserSettings() {
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
    const userEmail = this.getUserEmail();
    const flowEmail = this.getFlowOwnerEmail();
    if (userEmail && flowEmail && userEmail !== flowEmail) {
      this.presentCurrentUserOptions();
    } else {
      this.deleteFlow();
    }
  }

  presentCurrentUserOptions() {}

  deleteFlow() {
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
    const userEmail = this.getUserEmail();
    const flowEmail = this.getFlowOwnerEmail();
    var flowModel = {
      rowKey: this.flowData.rowKey,
      CustomerEmail: userEmail,
      FlowStatus: "Approved",
    };
    var navigateTo = localStorage.getItem("navigateTo");
    if (this.userData != null) {
      if (!userEmail || !flowEmail || userEmail === flowEmail) {
        this.isDeleting = true;
        this.dialogRef.disableClose = true;
        this.flowServiceService
          .deleteFlow(flowModel)
          .pipe(
            finalize(() => {
              this.isDeleting = false;
              this.dialogRef.disableClose = false;
            })
          )
          .subscribe({
            next: (data) => {
              const deleted = data === true || data?.Deleted === true;
              if (deleted) {
                this.toastr.success("Flow successfully deleted");
                this.dialogRef.close({ deleted: true });
                const onProfile =
                  this.router.url.includes("/user-profile") ||
                  navigateTo === "user-profile";
                if (!onProfile) {
                  setTimeout(() => this.router.navigate(["/user-profile"]), 0);
                }
              }
            },
            error: () => {
              this.toastr.error("Could not delete flow. Please try again.");
            },
          });
      }
    } else {
      this.router.navigate(["/" + navigateTo]);
    }
  }

  loadSteps(steps) {
    steps.forEach((element) => {
      this.dataSourceSteps.push({
        title: element.Title,
        url: element.Url,
        description: element.Description,
        id: element.Id,
        ShowImage: this.showimage,
      });
    });
  }

  close(): void {
    this.dialogRef.close({ deleted: false });
  }
}
